import React from "react";
import {
    BrowserRouter,
    Routes,
    Route
} from "react-router-dom";
import App from "../../App";
import { Exporter } from "../../pages/Exporter/Exporter";

interface IProps {

}

export function Router(props: IProps) {
    return (
        <BrowserRouter>
            <Routes>
                <Route index element={<App />} />
                <Route path={'/exporter'} element={<Exporter />} />
            </Routes>
        </BrowserRouter>
    )
}
